import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { Grid, Typography } from '@mui/material';
import { theme } from 'theme';
import { MemberCode } from 'views/MemberZoneAccess/MemberZoneStatus/MemberCode';
import { MemberZoneStatus } from 'views/MemberZoneAccess/MemberZoneStatus/MemberZoneStatus';
import { MemberZoneActions } from 'views/MemberZoneAccess/MemberZoneStatus/MemberZoneActions';
import { MemberZoneStatusSkeleton } from 'views/MemberZoneAccess/MemberZoneStatus/MemberZoneStatusSkeleton';
import { getMemberCodeThunk, setFetchMemberCodeError } from 'reducers/memberCodeStatusReducer';
import { setPartnerId } from 'reducers/partnerStatusReducer';
import { closeModal } from 'reducers/modalReducer';
import { selectPartnerId } from 'selectors/partnerStatusSelector';
import { selectFetchMemberCodeError, selectIsMemberCodeLoading } from 'selectors/memberCodeStatuSelector';
import { selectMemberCode } from 'selectors/memberCodeSelector';
import { CustomError } from 'types';
import { selectSelectedProduct } from 'selectors/tableSelector';
import { useErrorHandling } from 'components/hooks/useErrorHandling';
import { AppDispatch } from 'store';

export const MemberCodeOverview = () => {
  const partnerId: string | undefined = useSelector(selectPartnerId); // TODO - check if we need this when partner id is selected from the params
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const error: CustomError | undefined = useSelector(selectFetchMemberCodeError);
  const { partnerId: partnerNumberFromParam } = useParams<{
    partnerId: string;
  }>();

  const isLoading = useSelector(selectIsMemberCodeLoading);
  const memberCode: string = useSelector(selectMemberCode);
  const selected = useSelector(selectSelectedProduct);

  useEffect(() => {
    if (partnerNumberFromParam) {
      dispatch(setPartnerId(partnerNumberFromParam));
      dispatch(getMemberCodeThunk(partnerNumberFromParam));
    }
  }, [partnerNumberFromParam, dispatch, selected]);

  useErrorHandling(error, () => {
    navigate(`/partner?partnerNumber=${partnerId}`);
    dispatch(setFetchMemberCodeError(undefined));
    dispatch(closeModal());
  });

  return (
    <>
      <Grid style={{ paddingLeft: theme.spacing(4) }}>
        <Typography variant="h1">{`ACCESS TO 'FINANCIAL NEWS' ON JB MOBILE`}</Typography>
      </Grid>
      <Grid style={{ paddingLeft: theme.spacing(4) }}>
        {isLoading || !memberCode ? (
          <MemberZoneStatusSkeleton />
        ) : (
          <>
            <MemberZoneStatus />
            <MemberCode />
          </>
        )}
      </Grid>
      <MemberZoneActions />
    </>
  );
};
